import React from 'react';

const MyBuyers = () => {
    return (
        <div>
            My Buyers Page Comming Soon
        </div>
    );
};

export default MyBuyers;